export default "__VITE_ASSET__UmH1Fhs6__"